(function () {
  var root        = document.documentElement;
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ── Route classification ────────────────────────────────────────── */
  function classifyRoute(path) {
    if (!path) return 'external';
    try { path = new URL(path, location.href).pathname; } catch (e) { return 'external'; }
    var p = path.replace(/\/+$/, '') || '/';
    if (p === '/') return 'home';
    if (/\/products\//.test(p) || /\/pages\/.*(volt|inside|timing|glossary|formula)/.test(p)) return 'product';
    if (/\/pages\/.*(founder|story)/.test(p)) return 'editorial';
    if (/\/blogs\/[^/]+$/.test(p)) return 'journal';
    if (/\/blogs\//.test(p)) return 'article';
    return 'default';
  }

  var BRANDED = ['home', 'product', 'journal', 'article', 'editorial', 'cta', 'default'];

  function isBrandedType(t) { return BRANDED.indexOf(t) !== -1; }

  function getTransitionType(fromType, toType) {
    if (fromType === 'journal' && toType === 'article') return 'article';
    if (toType === 'editorial') return 'editorial';
    return 'ignition';
  }

  /* ── Stagger reveal ──────────────────────────────────────────────────
     Called synchronously in pagereveal — BEFORE the view-transition
     snapshot is captured. Elements start in their "from" state
     (opacity 0, translateY 12px, via animation-fill-mode: both)
     and emerge from within the wipe as it sweeps across the page.
     ──────────────────────────────────────────────────────────────────── */
  function initStaggerReveal() {
    var main = document.getElementById('main') ||
               document.querySelector('[role="main"]') ||
               document.querySelector('main');
    if (!main) return;

    var sections = Array.from(main.querySelectorAll('.shopify-section'));
    var order    = 0;
    var SELECTOR = [
      '[class*="__eyebrow"]', '[class*="__kicker"]',
      '[class*="__heading"]', '[class*="__title"]',
      '[class*="__intro"]',   '[class*="__subheading"]'
    ].join(', ');

    sections.slice(0, 2).forEach(function (section) {
      Array.from(section.querySelectorAll(SELECTOR)).forEach(function (el) {
        var tag = el.tagName;
        /* Skip sub-headings and elements already handled by scroll-reveal */
        if (tag === 'H3' || tag === 'H4' || tag === 'H5' || tag === 'H6') return;
        if (el.hasAttribute('data-ns-stagger') || el.hasAttribute('data-reveal')) return;
        el.setAttribute('data-ns-stagger', '');
        el.style.setProperty('--ns-stagger-i', order++);
      });
    });
  }

  /* ── pageswap: fires on the OLD page before screenshot ── */
  window.addEventListener('pageswap', function (event) {
    if (!event.viewTransition) return;

    var destUrl  = event.activation && event.activation.entry ? event.activation.entry.url : '';
    var fromType = classifyRoute(location.pathname);
    var toType   = classifyRoute(destUrl);

    if (motionQuery.matches || !isBrandedType(fromType) || !isBrandedType(toType)) {
      event.viewTransition.skipTransition();
    }
  });

  /* ── pagereveal: fires on the NEW page before transition starts ── */
  window.addEventListener('pagereveal', function (event) {
    if (!event.viewTransition) return;

    var fromPath = document.referrer || '';
    var toPath   = location.pathname;
    var fromType = classifyRoute(fromPath);
    var toType   = classifyRoute(toPath);

    if (motionQuery.matches || !isBrandedType(toType)) {
      event.viewTransition.skipTransition();
      return;
    }

    /* Set transition type for CSS route-variant selectors.
       This is synchronous — the attribute is visible to the browser's
       CSS engine when it evaluates ::view-transition-new(root) rules. */
    var transType = getTransitionType(fromType, toType);
    root.setAttribute('data-ns-trans', transType);

    /* Stagger: set data attributes synchronously (before snapshot),
       so hero elements begin hidden and emerge during the wipe. */
    initStaggerReveal();

    /* Clean up after the transition finishes */
    event.viewTransition.finished.then(function () {
      root.removeAttribute('data-ns-trans');
    });
  });

  /* ── Fallback — browsers without cross-document View Transitions ── */
  var leaving = false;

  function hasNativeTransitions() {
    return 'onpageswap' in window && 'onpagereveal' in window;
  }

  function shouldUseFallback(anchor, event) {
    if (leaving || motionQuery.matches || hasNativeTransitions()) return false;
    if (event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (!anchor || !anchor.href || anchor.hasAttribute('download')) return false;
    if (anchor.target && anchor.target !== '_self') return false;
    if (anchor.closest('[data-no-instant], [data-no-page-transition], [aria-controls]')) return false;

    try {
      var url = new URL(anchor.href, location.href);
      if (url.origin !== location.origin) return false;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return false;
      return isBrandedType(classifyRoute(location.pathname)) &&
             isBrandedType(classifyRoute(url.pathname));
    } catch (e) { return false; }
  }

  function installFallback() {
    root.classList.add('ns-page-transition-fallback');

    window.addEventListener('pageshow', function () {
      root.classList.remove('ns-page-transition-leaving');
      root.classList.add('ns-page-transition-entering');
      setTimeout(function () { root.classList.remove('ns-page-transition-entering'); }, 420);
    });

    document.addEventListener('click', function (event) {
      var anchor = event.target.closest && event.target.closest('a[href]');
      if (!shouldUseFallback(anchor, event)) return;
      event.preventDefault();
      leaving = true;
      root.classList.add('ns-page-transition-leaving');
      setTimeout(function () { location.href = anchor.href; }, 200);
    });
  }

  if (!hasNativeTransitions()) {
    installFallback();
  }

  /* ── Prefetch on hover / touch ──────────────────────────────────────
     Starts loading the next page while the user is still deciding,
     so the transition feels instant rather than waiting on Shopify.
     ──────────────────────────────────────────────────────────────────── */
  var prefetched = new Set();

  function prefetchUrl(href) {
    if (!href || prefetched.has(href)) return;
    if (/\/(cart|checkout|account)/.test(href)) return;
    prefetched.add(href);
    var link  = document.createElement('link');
    link.rel  = 'prefetch';
    link.as   = 'document';
    link.href = href;
    document.head.appendChild(link);
  }

  function sameOriginAnchor(target) {
    var a = target && target.closest && target.closest('a[href]');
    if (!a) return null;
    try {
      return new URL(a.href, location.href).origin === location.origin ? a : null;
    } catch (e) { return null; }
  }

  document.addEventListener('mouseover', function (event) {
    var a = sameOriginAnchor(event.target);
    if (a) prefetchUrl(new URL(a.href, location.href).href);
  });

  document.addEventListener('touchstart', function (event) {
    var a = sameOriginAnchor(event.target);
    if (a) prefetchUrl(new URL(a.href, location.href).href);
  }, { passive: true });

  /* ── Journal card → article hero shared element ─────────────────────
     On click: tag the clicked card's media element with the shared name.
     The article header has the same name baked into its markup.
     The browser then animates the image morphing from card to hero.
     ──────────────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (event) {
    var card = event.target.closest && event.target.closest('.ns-journal-card');
    if (!card || !card.href) return;

    /* Clear any previously set names — view-transition-name must be unique */
    document.querySelectorAll('.ns-journal-card__media').forEach(function (m) {
      m.style.viewTransitionName = '';
    });

    var media = card.querySelector('.ns-journal-card__media');
    if (media && media.querySelector('img')) {
      media.style.viewTransitionName = 'ns-article-hero';
    }
  });

})();

/* ── Header glassmorphism on scroll ─────────────────────────────────
   Toggles ns-header--scrolled on the section element.
   CSS handles the background-color transition + backdrop-filter.
   ──────────────────────────────────────────────────────────────────── */
(function () {
  var section = document.querySelector('.shopify-section--header');
  if (!section) return;

  function tick() {
    section.classList.toggle('ns-header--scrolled', window.scrollY > 60);
  }

  window.addEventListener('scroll', tick, { passive: true });
  tick();
})();
